











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { QuestionFileModel } from "survey-core";
@Component
export class FileCleanButton extends Vue {
  @Prop() question: QuestionFileModel;
  @Prop() css: any;
}
Vue.component("sv-file-clean-btn", FileCleanButton);
export default FileCleanButton;
